<template>
<tr>
  <td class="tableinforcolor">
    <p class="tr mr-4">{{title}}</p>
  </td>
  <td>
    <slot></slot>
  </td>
</tr>
</template>
<script>
export default {
  props: {
		title: {
			type: String
    }
  }
}
</script>